import { Navigate, useParams } from 'react-router-dom';
import { ROUTE_PATTERNS, buildRoute } from '../constants/Paths';

/**
 * /scans/:id/flagged-content merged into the scan report's Flagged tab.
 * This keeps old bookmarks and shared links working.
 */
export default function FlaggedContentRedirect() {
	const { id } = useParams();
	return <Navigate to={buildRoute(ROUTE_PATTERNS.SCAN_DETAIL, { id })} replace />;
}
